/*
 * Module for the Pending Benefits criteria page
 */
rs.module("content/reports/pendingbenefitscriteria",

    [ /* dependencies */],

    function () {

        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var benefitsToIncludeSelect = criteria.js(jsSelectors.benefitSelect);
            var fromDatePicker = criteria.js(jsSelectors.fromDatePicker);
            var toDatePicker = criteria.js(jsSelectors.toDatePicker);

            enableDisableFields();

            benefitsToIncludeSelect.change(enableDisableFields);

            function enableDisableFields() {

                var allBenefits = benefitsToIncludeSelect.val() == "All";

                // enable/disable effective date pickers based on benefits to include 
                fromDatePicker.prop("disabled", allBenefits);
                toDatePicker.prop("disabled", allBenefits);

                // clear effective date pickers if including all benefits
                if (allBenefits) {
                    fromDatePicker.val("");
                    toDatePicker.val("");
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);